import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { InputSharedComponent } from './input.component';
import { IconSharedModule } from '../../atoms/icon/icon.module';
import { SpinnerSharedModule } from '../../atoms/spinner/spinner.module';

@NgModule({
    declarations: [
        InputSharedComponent
    ],
    imports: [
        CommonModule,
        IconSharedModule,
        SpinnerSharedModule
    ],
    exports: [
        InputSharedComponent
    ]
})

export class InputSharedModule {}
